import { render, staticRenderFns } from "./AdvertisingInfo.vue?vue&type=template&id=c70b2f9e&"
import script from "./AdvertisingInfo.vue?vue&type=script&lang=js&"
export * from "./AdvertisingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports